import { AnalyticsStore } from 'bernie-core';
import * as React from 'react';
import { LinkTracked, AnchorTracked } from '../../../utils/click-trackers';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { ActivityMessageDialog } from '../activity-message-dialog';
import { trackAction } from './activity-message-banner-helper';
import { ACTIVITY_LINK_CLICK_ACTION, ACTIVITY_POPUP_CLICK_ACTION } from './';

export function ActivityMessageBannerLink(
  activityMessageAction: ActivityDestinationViewSearch.First | ActivityDestinationViewSearch.Second,
  analyticsStore: AnalyticsStore | undefined
): JSX.Element {
  let messageBannerLink = <></>;
  const { clickAction } = activityMessageAction;
  const analytics = clickAction?.analytics;
  if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION && clickAction.anchorTagUrl) {
    messageBannerLink = (
      <AnchorTracked
        linkName={analytics?.linkName}
        rfrr={analytics?.referrerId}
        href={clickAction.anchorTagUrl}
        target={clickAction.opensInNewTab ? '_blank' : '_self'}
        rel="noopener"
        className="uitk-type-300"
        data-testid="activity-message-banner-anchor-link"
      >
        {activityMessageAction.text}
        {clickAction.accessibilityText && <span className="is-visually-hidden">{clickAction.accessibilityText}</span>}
      </AnchorTracked>
    );
  } else if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION) {
    messageBannerLink = (
      <LinkTracked
        rfrr={analytics?.referrerId}
        linkName={analytics?.linkName}
        to={clickAction.linkTagUrl}
        onClick={trackAction.bind(null, analytics?.referrerId as string, analyticsStore)}
        className="uitk-type-300"
        data-testid="activity-message-banner-router-link"
      >
        {activityMessageAction.text}
        {clickAction.accessibilityText && <span className="is-visually-hidden">{clickAction.accessibilityText}</span>}
      </LinkTracked>
    );
  } else if (clickAction.__typename === ACTIVITY_POPUP_CLICK_ACTION) {
    messageBannerLink = <ActivityMessageDialog activityMessageAction={activityMessageAction} />;
  } else {
    messageBannerLink = (
      <LinkTracked
        rfrr={analytics?.referrerId}
        linkName={analytics?.linkName}
        to={'#'}
        onClick={trackAction.bind(null, analytics?.referrerId as string, analyticsStore)}
        className="uitk-type-300"
        data-testid="activity-message-banner-router-link"
      >
        {activityMessageAction.text}
      </LinkTracked>
    );
  }

  return messageBannerLink;
}
